export const SET_SUCCESS_COBRO_EXPRESS =
  "[COBRO_EXPRESS] REQUEST PAYMENT SUCESS";
export const SET_ERROR_COBRO_EXPRESS = "[COBRO_EXPRESS] REQUEST PAYMENT ERROR";
export const CLEAR_SUCCESS = "[COBRO_EXPRESS] REQUEST PAYMENT CLEAR SUCCESS";
export const CLEAR_ERROR = "[COBRO_EXPRESS] REQUEST PAYMENT CLEAR ERROR";
export const ADD_EXPRESS_CHARGES = "ADD_EXPRESS_CHARGE";
